// Physical hold/tape colours a setter can tag a route with — unrelated to the
// grade's display colour, which now lives in the gym's grade_config.
export const ROUTE_COLORS = [
  { value: '#ef4444', label: 'Roșu' },
  { value: '#f97316', label: 'Portocaliu' },
  { value: '#eab308', label: 'Galben' },
  { value: '#22c55e', label: 'Verde' },
  { value: '#3b82f6', label: 'Albastru' },
  { value: '#a855f7', label: 'Mov' },
  { value: '#ec4899', label: 'Roz' },
  { value: '#ffffff', label: 'Alb' },
  { value: '#6b7280', label: 'Gri' },
  { value: '#111827', label: 'Negru' },
] as const

// The add/edit route forms are taller than a phone screen. On mobile they open
// as a bottom sheet whose body scrolls between a pinned title and pinned
// buttons; from `sm` up they are an ordinary centred dialog.
export const ROUTE_SHEET_PROPS = {
  placement: 'auto',
  scrollBehavior: 'inside',
  classNames: {
    base: 'm-0 max-h-[92dvh] rounded-b-none sm:m-6 sm:rounded-b-large',
    header: 'border-b border-divider',
    footer: 'border-t border-divider pb-[max(1rem,env(safe-area-inset-bottom))]',
  },
} as const
